import {createNotification} from "./createNotification";
import {ItemModelType} from "@stores/WorkspaceStore";
import { CrudServices } from "../../platform/services/types/ServiceDependencies";
import { UserSessionState } from "@stores/UserSessionState";

export const ackNotifyUser = (
    services: CrudServices,
    userState: UserSessionState,
    userId: string,
    itemMST: ItemModelType
) => {
    return createNotification(services, userState, {
        type: 'ack_require',
        userId: userId,
        initiatorId: userState.currentUserId!,
        meta: JSON.stringify({
            wsId: itemMST.workspaceId,
            itemId: itemMST.id,
            itemName: itemMST.name,
        }),
    })
}

